<script>
  import { slide } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  import { t, lang } from "../i18n";
  import LangSpan from "../ui/LangSpan.svelte";
  import SearchBox from "./SearchBox.svelte";
  import CloseButton from "../ui/CloseButton.svelte";

  const dispatch = createEventDispatcher();
</script>

<div class="search-popup cna-slide-in-left">
  <CloseButton on:click={() => dispatch("hide")} />
  <p class="search-prefix"><LangSpan key="search-popup-prefix" /></p>
  <SearchBox placeholderText={t("search-popup-placeholder", $lang)} on:select />
</div>

<style>
  .search-popup {
    position: fixed;
    top: 110px;
    left: 10px;
    border-radius: 5px;
    flex-direction: column;
    align-items: center;
    background-color: white;
    width: 400px;
    z-index: 20;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 3px 0 rgba(0, 0, 0, 0.06);
    padding: 22px 22px;
  }

  .search-prefix {
    font-size: 1.5rem;
    margin: 0;
    color: #222;
    padding-bottom: 0.5rem;
  }

  .cna-slide-in-left {
    -webkit-animation: cna-slide-in-left 250ms forwards;
    animation: cna-slide-in-left 250ms forwards;
    -webkit-transform: translate(-50vw, 0);
    -ms-transform: translate(-50vw, 0);
    transform: translate(-50vw, 0);
  }

  @keyframes cna-slide-in-left {
    from {
      -webkit-transform: translate(-50vw, 0);
      transform: translate(-50vw, 0);
    }
    to {
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
    }
  }
</style>
